import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const ReportsApi = {
  async index(query) {
    const { data } = await http.get(`${teamPath()}/reports`, { params: query });
    return data || {};
  },

  async store(data) {
    const response = await http.post(`${teamPath()}/reports`, data);
    return response.data.data || {};
  },

  async show(id) {
    const response = await http.get(`${teamPath()}/reports/${id}`);
    return response.data.data || {};
  },
};
